// frontend/src/pages/ProductInfo.jsx
import React, { useEffect, useState } from "react";
import { TextInput } from "../ui/UIComponents"; // use global input :contentReference[oaicite:0]{index=0}

export default function ProductInfo() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch("/product-info.json", { cache: "no-store" });
        if (!res.ok) throw new Error("Không tải được danh sách. Hãy kiểm tra product-info.json");
        const data = await res.json();
        setItems(Array.isArray(data?.items) ? data.items : []);
      } catch (e) {
        setError(e.message || "Load failed");
      }
    }
    load();
  }, []); // from original page :contentReference[oaicite:1]{index=1}

  const filtered = items.filter((f) => {
    if (!query.trim()) return true;
    const q = query.toLowerCase();
    return (
      f.title.toLowerCase().includes(q) ||
      (f.desc && f.desc.toLowerCase().includes(q))
    );
  });

  return (
    <div className="app-page">
      <main className="container">
        <h2 style={{ marginBottom: 12 }}>Thông tin sản phẩm / Product Information</h2>

        {/* swapped native input -> global TextInput (UI-only change) */}
        <div style={{ marginBottom: 16, maxWidth: 400 }}>
          <TextInput
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            type="text"
            aria-label="Search products"
            placeholder="🔍 Tìm kiếm / Search..."
          />
        </div>

        {error && (
          <div className="box" style={{ color: "crimson" }}>
            ✖ {error}
          </div>
        )}

        {!error && filtered.length === 0 && (
          <div className="box" style={{ opacity: 0.8 }}>
            Không có kết quả. / No matching results.
          </div>
        )}

        <div className="menu-grid">
          {filtered.map((f, idx) => (
            <a
              key={idx}
              className="menu-card"
              href={f.url}
              target="_blank"
              rel="noopener noreferrer"
              title={`Download ${f.title}`}
              style={{ textDecoration: "none" }}
            >
              <span className="menu-id">{idx + 1}.</span>
              <span className="menu-text">
                {f.title}
                {f.desc ? (
                  <span style={{ display: "block", fontSize: 12, opacity: 0.7 }}>
                    {f.desc}
                  </span>
                ) : null}
              </span>
            </a>
          ))}
        </div>
      </main>
    </div>
  );
}
